import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../reducers';

export const Show = createSelector(
	getSharedFeatureState,
	state => state.spinner.show
);

